// extracted by mini-css-extract-plugin
export default {"LoadMoreSection":"LoadMoreSection_LoadMoreSection__K5ett"};